module.exports = __webpack_public_path__ + "media/images/mobile/audio-6b9c40f42c3c7b3370f6e2a6d9df24f0.svg";